import axios from "axios";
import { toast } from "react-toastify";
import { config } from "../alerts/index";
import create from "zustand";
import { randomString } from "../helper"

// @firebase
import { db } from "../../../../config/firebase.config";
import {
  collection,
  addDoc,
  setDoc,
  onSnapshot,
  serverTimestamp,
  doc,
} from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import api from "../../../api/index";
export const useStore = create((set, get) => ({
  customer: null,
  warranties: [],
  serialExist: false,
  warrantyRegistry: async (payload) => {
    //TO DO: firebase storage setup
    try {
      // 🐇🥚: Below uploads a file to firebase storage
      const storage = getStorage();
      // Creating file directory in firebase storage
      const proofRef = ref(storage, `warranty/${randomString()}/${payload.proof.name}`);
      // Uploading file to firebase storage
      const snapshot = await uploadBytes(proofRef, payload.proof)
      // Getting file from firebase storage
      const proofURL = await getDownloadURL(snapshot.ref)
      // 🐇🥚: Above uploads a file to firebase storage
      const collectionsRef = collection(db, "warranties");
      // Creates new document in firestore with randomly generated id
  
      const {purchaseDate, firstName, lastName, email, phone} = payload.formDetails
      addDoc(collectionsRef, {
        bikeDealer: payload.dealer,
        purchaseDate,
        firstName,
        lastName,
        email,
        phone,
        purchaseProof: proofURL ,
        createdAt: serverTimestamp(),
      });
      const response = await api.sendWarranty({
        bikeSerial: payload.formDetails.serial,
        bikeDealer: payload.dealer,
        bikePurchaseDate: payload.formDetails.purchaseDate,
        firstName: payload.formDetails.firstName,
        lastName: payload.formDetails.lastName,
        email: payload.formDetails.email,
        phone: payload.formDetails.phone,
        purchaseProof: proofURL
      })
      payload.setLoading(false)
      toast("Warranty Registered.", { ...config, type: "success" });
    } catch (error) {
      toast(error.message, { ...config, type: "error" });
      console.log('error on warrenty submit', error)
      payload.setLoading(false)
    }
  },

  registry: async (payload) => {
    const { formDetails, model, setLoading, dealer, proof } = payload;

    const email = formDetails.email;
    const firstName = formDetails.firstName;
    const lastName = formDetails.lastName;
    const password = `${firstName}${lastName}`;

    const registerDetails = {
      email,
      firstName,
      lastName,
      password,
    };
    let arr = [];
    try {
      await axios.post(`/account/register`, registerDetails);
      await axios.post(`/account/login`, {
        email: registerDetails.email,
        password: registerDetails.password,
      });
      const response = await axios.post(`/account/user`);
      localStorage.setItem("customer", JSON.stringify(response.data.customer));
      set({ customer: response.data.customer });
      const id = get().customer.id;
      const uid = id.split("Customer/").pop();
      setDoc(doc(db, "users", uid), {
        id: id,
        email: email,
        firstName: firstName,
        lastName: lastName,
        cart: [],
        createdAt: serverTimestamp(),
        lastModified: serverTimestamp(),
      });
      // create subcollection
      const collectionsRef = collection(db, "users", uid, "warranties");

      onSnapshot(collectionsRef, (snapshot) => {
        if (arr.length > 0) {
          arr.splice(0, arr.length);
        }

        snapshot.docs.map((doc) => {
          var item = {
            ...doc.data(),
            id: doc.id,
          };
          arr.push(item);
          if (item.serial == formDetails.serial) {
            set({
              serialExist: true,
            });
          }
        });
      });

      const doit = () => {
        addDoc(collectionsRef, {
          ...formDetails,
          model: model,
          dealership: dealer || "",
          proof: proof,
          createdAt: serverTimestamp(),
        });
      };
      const checker = get().serialExist;
      if (checker == true) {
        toast("The serial number has already been used", {
          ...config,
          type: "error",
        });
      } else {
        doit();
        toast("Warrenty form Submitted", { ...config, type: "success" });
      }
      setLoading(false);
      return;
    } catch (error) {
      setLoading(false);
      return error.message;
    }
  },

  fetchWarranties: async (uid) => {
    try {
      let arr = [];
      const collectionsRef = collection(db, "users", uid, "warranties");

      onSnapshot(collectionsRef, (snapshot) => {
        if (arr.length > 0) {
          arr.splice(0, arr.length);
        }

        snapshot.docs.map((doc) => {
          var item = {
            ...doc.data(),
            id: doc.id,
          };
          arr.push(item);
        });
        set({
          warranties: arr,
        });
      });
      return arr;
    } catch (e) {
      toast("Error fetching warranties ", {
        ...config,
        type: "error",
      });
    }
  },
  passwordMail: async (payload) => {
    try {
      const response = await axios.post("/warranty", payload);
      toast(response.data, { ...config, type: "success" });
    } catch (error) {
      toast("Password detaails failed to send", { ...config, type: "error" });
      return error.message;
    }
  },
}));
